(function () {

    'use-strict';

    angular
        .module('jotApp')
        .directive('recursiveRow', RecursiveRow);

    RecursiveRow.$inject = ['$timeout', '$state', '$uibModal'];

    function RecursiveRow($timeout, $state, $uibModal)
    {
        var directive = {
            restrict: 'A',
            templateUrl: 'app/entities/tab-object-types/recursive-row.html',
            scope: {
                model: '=',
                visibility: '='
            },
            link: function (scope, el, attrs)
            {
                scope.toggleChildren = function (model){
                    model.childrenVisible = !model.childrenVisible;
                    model.folderClass = model.childrenVisible ? "fa-minus-square":"fa-plus-square";
                };
                scope.clickHere = function(array){
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-object-types/insert-object.html',
                        controller: 'InsertObjectMappingType',
                        controllerAs: 'vm',
                        size: 'md'
                    }).result.then(function () {
                        var newObject = localStorage.getItem("insert-new-object");
                        if(newObject != null && newObject != "null" && newObject != undefined){
                            newObject = JSON.parse(newObject);
                        }
                        localStorage.setItem("insert-new-object", JSON.stringify({}));
                        array.push(newObject);
                    });
                    $timeout(function ()
                    {
                        el.replaceWith(el.children());
                    });
                };
                $timeout(function ()
                {
                    el.replaceWith(el.children());
                });
            }
        };
        return directive;
    }

})();
